import { createSlice } from '@reduxjs/toolkit';
import { setMonitorEnabled } from 'features/admin-monitoring/async';
import { saveMonitorSettings } from 'features/admin-monitoring/dependencies/async';
import { getMonitors } from 'features/admin-monitoring/directory/async';
import { MonitoringDirectoryState } from 'features/admin-monitoring/directory/types';
import {
  fulfilled,
  initialRequestState,
  pending,
  rejected,
  requestReducer,
} from 'features/shared/request';

export const initialState: MonitoringDirectoryState = {
  monitors: { data: undefined, request: initialRequestState },
  togglingKeys: [],
};

const slice = createSlice({
  name: 'monitoringDirectory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMonitors.pending, (state, { meta }) => {
      state.monitors.data = undefined;
      state.monitors.request = requestReducer(
        state.monitors.request,
        pending({ meta })
      );
    });
    builder.addCase(getMonitors.fulfilled, (state, { meta, payload }) => {
      if (state.monitors.request.id === meta.requestId) {
        state.monitors.data = payload;
        state.monitors.request = requestReducer(
          state.monitors.request,
          fulfilled({ meta })
        );
      }
    });
    builder.addCase(getMonitors.rejected, (state, { meta }) => {
      state.monitors.request = requestReducer(
        state.monitors.request,
        rejected({ meta })
      );
    });

    builder.addCase(saveMonitorSettings.fulfilled, (state, { payload }) => {
      const { monitor: savedMonitor } = payload;
      if (savedMonitor) {
        state.monitors.data = state.monitors.data?.map((monitor) =>
          monitor.monitorKey === savedMonitor.monitorKey
            ? savedMonitor
            : monitor
        );
      }
    });

    builder.addCase(setMonitorEnabled.pending, (state, { meta }) => {
      if (!state.togglingKeys.includes(meta.arg.monitorKey)) {
        state.togglingKeys.push(meta.arg.monitorKey);
      }
    });
    builder.addCase(setMonitorEnabled.fulfilled, (state, { meta, payload }) => {
      state.monitors.data = state.monitors.data?.map((monitor) =>
        monitor.monitorKey === meta.arg.monitorKey ? payload : monitor
      );
      state.togglingKeys = state.togglingKeys.filter(
        (key) => key !== meta.arg.monitorKey
      );
    });
    builder.addCase(setMonitorEnabled.rejected, (state, { meta }) => {
      state.togglingKeys = state.togglingKeys.filter(
        (key) => key !== meta.arg.monitorKey
      );
    });
  },
});

const { reducer } = slice;

export default reducer;
